import { GetListParams, GetOneParams, useNotify } from 'react-admin';
import { CustomDataProvider } from '../../providers/CustomDataProvider';
import { baseUrl, httpClient } from '../../providers/AppDataProvider';
import { getAuth } from '../../providers/AppAuthProvider';
import axios from 'axios';

export class BannersDataProvider implements CustomDataProvider {
  // eslint-disable-next-line class-methods-use-this
  async getList(resource: string, params: GetListParams): Promise<any> {
    if (resource !== 'banners') return Promise.reject(new Error('Unsupported getList resource'));

    const { filter = {} } = params;
    const platform = filter?.platform || 'ALL';
    const category = filter?.category;

    const url = `${baseUrl}/banners`;
    const { page = 1, perPage = 10 } = params.pagination || {};

    try {
      // GET /banners 需要 POST body
      const { json } = await httpClient(url, {
        method: 'GET',
      });

      const rows: any[] = json?.data ?? [];
      // 客户端筛选 platform
      const filteredRows = rows.filter((row: any) => {
        // 平台筛选
        if (platform !== 'ALL') {
          const rowPlatform = row?.platform;
          if (rowPlatform !== platform) return false;
        }

        // 分类筛选（前缀匹配：只要行分类以筛选category开头，即视为匹配）
        if (category) {
          const rowCategory = row?.category;
          // 1. 先判断rowCategory是否存在（避免undefined/null调用startsWith报错）
          // 2. 使用startsWith方法判断前缀匹配
          if (!rowCategory || !rowCategory.includes(category)) {
            return false;
          }
        }

        return true;
      });

      const total = filteredRows.length;

      // 确保每条记录都有 id
      const allData = filteredRows.map((r: any, i: number) => {
        const row = r?.id != null ? r : { id: `${i}`, ...r };
        // return normalizeStatus(row);
        return row;
      });
      // 前端分页处理
      const startIndex = (page - 1) * perPage;
      const endIndex = startIndex + perPage;
      const data = allData.slice(startIndex, endIndex);
      return { data, total };
    } catch (error) {
      console.error('BannersDataProvider getList error:', error);
      throw error;
    }
  }
  // eslint-disable-next-line class-methods-use-this
  async getOne(resource: string, params: GetOneParams): Promise<any> {
    if (resource !== 'banners') return Promise.reject(new Error('Unsupported getOne resource'));

    const url = `${baseUrl}/banners/${params.id}`;

    try {
      const { json } = await httpClient(url);
      const data = json?.data?.[0] ?? json?.data ?? json;

      if (!data) {
        throw new Error('Banner not found');
      }

      return { data };
    } catch (error) {
      console.error('BannersDataProvider getOne error:', error);
      throw error;
    }
  }

  // eslint-disable-next-line class-methods-use-this
  async create(resource: string, params: any): Promise<any> {
    if (resource !== 'banners') return Promise.reject(new Error('Unsupported create resource'));

    const url = `${baseUrl}/banners`;
    const payload = params?.data ?? {};
    if (payload.isActive === true) {
      payload.isActive = 1;
    }
    if (payload.isActive === false) {
      payload.isActive = -1;
    }
    if (payload.isInternalRoute === true) {
      payload.isInternalRoute = 1;
    }
    if (payload.isInternalRoute === false) {
      payload.isInternalRoute = 0;
    }

    try {
      const { json } = await httpClient(url, {
        method: 'POST',
        body: JSON.stringify(payload),
      });
      if (json.data === null && json.errors.length > 0) {
        throw new Error(json.errors[0].message);
      }
      return { data: json?.data ?? json };
    } catch (error) {
      console.error('BannersDataProvider create error:', error);
      throw error;
    }
  }

  // eslint-disable-next-line class-methods-use-this
  async update(resource: string, params: any): Promise<any> {
    if (resource !== 'banners') return Promise.reject(new Error('Unsupported update resource'));

    const url = `${baseUrl}/banners`;
    const payload = params?.data ?? {};
    if (payload.isActive === true) {
      payload.isActive = 1;
    }
    if (payload.isActive === false) {
      payload.isActive = -1;
    }
    if (payload.isInternalRoute === true) {
      payload.isInternalRoute = 1;
    }
    if (payload.isInternalRoute === false) {
      payload.isInternalRoute = 0;
    }
    try {
      const { json } = await httpClient(url, {
        method: 'PUT',
        body: JSON.stringify(payload),
      });

      return { data: json?.data ?? json };
    } catch (error) {
      console.error('BannersDataProvider update error:', error);
      throw error;
    }
  }

  // eslint-disable-next-line class-methods-use-this
  async delete(resource: string, params: any): Promise<any> {
    if (resource !== 'banners') return Promise.reject(new Error('Unsupported delete resource'));

    const url = `${baseUrl}/banners`;
    const payload = params?.data ?? {};
    console.log('BannersDataProvider delete params:', params);

    // 转换 isActive: true -> 1, false -> -1 (API 需要数字)
    payload.isActive = -1;
    console.log('BannersDataProvider delete payload:', payload);

    try {
      const { json } = await httpClient(url, {
        method: 'PUT',
        body: JSON.stringify(payload),
      });
      console.log('BannersDataProvider delete json:', json);

      // return { data: json?.data ?? json };
      return { data: json ?? { id: payload.id } };
    } catch (error) {
      console.error('BannersDataProvider update error:', error);
      throw error;
    }
  }

  // eslint-disable-next-line class-methods-use-this
  async getUploadCfg(resource: string): Promise<any> {
    if (resource !== 'banners') return Promise.reject(new Error('Unsupported getUploadCfg'));

    const url = `${baseUrl}/banners/getUploadCfg`;

    const { accessToken } = (await getAuth()) || {};
    if (!accessToken) {
      throw new Error('Access token not obtained, please log in first');
    }

    const headers = {
      Authorization: `Bearer ${accessToken}`,
      Accept: 'application/json',
      // 'Content-Type': 'application/json',
    };
    try {
      /*
        {
            "uploadUrl": "https://unstable-api.xbit.live/api/cdn-service/upload",
            "fileType": "IMAGE",
            "tag": "banners",
            "pathPrefix": "banners"
        }
      */
      const response = await axios.get<any>(url, { headers });
      // console.log('getUploadCfg === ', response.data);
      return response.data;
    } catch (error) {
      // 错误处理：方便调试
      console.error('getUploadCfg fail:', error);
      if (axios.isAxiosError(error)) {
        const errorMessage = error.response?.data?.message || error.message || 'getUploadCfg error';
        console.error('errors:', {
          status: error.response?.status,
          statusText: error.response?.statusText,
          headers: error.response?.headers,
          data: error.response?.data,
        });
        throw new Error(errorMessage);
      }
      throw new Error('fail to get getUploadCfg');
    }
  }
}

// 创建实例并导出
// @ts-ignore
export const bannersDataProvider = new BannersDataProvider();
